import { render, staticRenderFns } from "./menuSelect.vue?vue&type=template&id=b3f11ed0&scoped=true"
import script from "./menuSelect.vue?vue&type=script&lang=js"
export * from "./menuSelect.vue?vue&type=script&lang=js"
import style0 from "./menuSelect.vue?vue&type=style&index=0&id=b3f11ed0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f11ed0",
  null
  
)

export default component.exports